import { useCallback, useEffect, useRef, useState } from "react";

export function useFlash(ms = 2000) {
  const [message, setMessage] = useState("");
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);
  const flash = useCallback(
    (text) => {
      clearTimeout(timer.current);
      setMessage(text);
      timer.current = setTimeout(() => setMessage(""), ms);
    },
    [ms],
  );
  return [message, flash];
}
